import { useContext } from "react";
import BodySchema from "./BodySchema";
import Credential from "./Credential";
import { FormContext } from "./FormField";

function WebhookFields() {
  const { fields } = useContext(FormContext);
  switch (fields.webhook_for) {
    case "GENERIC":
      return <BodySchema />;
    case "OTRS_TICKET":
      return <Credential />;
    default:
      return <></>;
  }
}

export default WebhookFields;
